export default {"src":"/_next/static/media/minillus-check.2c633ebf.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};